import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=dc18dc6c&scoped=true&"
import script from "./Logo.vue?vue&type=script&lang=ts&"
export * from "./Logo.vue?vue&type=script&lang=ts&"
import style0 from "./Logo.vue?vue&type=style&index=0&id=dc18dc6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc18dc6c",
  null
  
)

export default component.exports